"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadspediaApi = void 0;
const LeadspediaApiBase_1 = require("../lib/LeadspediaApiBase");
const ClientActions_1 = require("./ClientActions");
class LeadspediaApi extends LeadspediaApiBase_1.LeadspediaApiBase {
    constructor({ transformers, fieldMappings, apiUrl = "https://api.carloanscanada.com", leadType = "credit", ...options } = {}) {
        super({
            ...options,
            client: new ClientActions_1.ClientActions(apiUrl, leadType, {
                transformers,
                fieldMappings,
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
            }),
        });
    }
}
exports.LeadspediaApi = LeadspediaApi;
//# sourceMappingURL=index.js.map